import { useAuth } from "@/context/AuthContext";


export const can = (user, ...perms) =>
  user?.role === "owner" || perms.some((p) => (user?.permissions || []).includes(p));

export const isOwner = (user) => user?.role === "owner";

export const canManageEmployees = (user) => can(user, "org_settings.view");

export function useCan() {
  const { user } = useAuth();
  return (...perms) => can(user, ...perms);
}

export const P = {
  dashboard: ["dashboard.view"],
  catalog: ["catalog.view"],
  orders: ["orders.view", "procurement.view", "logistics.view"],
  inventory: ["inventory.view"],
  reports: ["reports.view", "sales.view", "finance.view"],
  partners: ["partners.view"],
};
